// Frontend configuration - API_BASE determined by hostname
// Single source of truth for API URL

const hostname = window.location.hostname;

// Determine API base from hostname + server-injected environment.
//
// Partner subdomains (e.g., vchealth.healist.ai) route through the SAME ALB as the
// main site, so they must use the same API as the environment that served the page.
// server.js injects window.__HEALIST_ENV__ ('development' | 'production') before
// the React bundle loads.  This tells us which API to use for any *.healist.ai host.

const healistEnv = window.__HEALIST_ENV__ || 'development';

let API_BASE;
if (hostname === 'localhost' || hostname === '127.0.0.1') {
  API_BASE = 'http://localhost:8001';
} else if (hostname === 'healist.ai' || hostname === 'www.healist.ai') {
  API_BASE = 'https://api.healist.ai';
} else if (hostname.startsWith('dev.') || hostname.startsWith('dev-api.')) {
  API_BASE = 'https://dev-api.healist.ai';
} else if (hostname.endsWith('.healist.ai')) {
  // Partner subdomain (vchealth.healist.ai, summit-health.healist.ai, etc.)
  // Use the env injected by server.js to pick the right API.
  API_BASE = healistEnv === 'production'
    ? 'https://api.healist.ai'
    : 'https://dev-api.healist.ai';
} else {
  // Custom domain — use env to determine API
  API_BASE = healistEnv === 'production'
    ? 'https://api.healist.ai'
    : 'https://dev-api.healist.ai';
}

// Helper: true if this is a development environment (localhost, dev.*, or partner subdomain in dev)
const isDev = hostname === 'localhost' || hostname === '127.0.0.1'
  || hostname.startsWith('dev.')
  || (hostname.endsWith('.healist.ai') && healistEnv !== 'production');

// Stripe publishable key (public — safe for frontend)
let STRIPE_PUBLISHABLE_KEY;
if (isDev) {
  STRIPE_PUBLISHABLE_KEY = ''; // Set after Stripe dashboard setup
} else {
  STRIPE_PUBLISHABLE_KEY = ''; // Set after Stripe dashboard setup
}

// Retry a fetch ONCE on a transient NETWORK failure. A CDN↔origin connection reset
// surfaces as a thrown TypeError / net::ERR_FAILED (NOT an HTTP status), which the
// browser mislabels as "No Access-Control-Allow-Origin header." Used by the background
// pollers (credits, notifications) so a dropped poll silently re-fetches on a fresh
// connection instead of leaving a console error. (#43, 2026-06-10)
async function fetchWithRetry(doFetch, retries = 1, delayMs = 1000) {
  try {
    return await doFetch();
  } catch (err) {
    if (retries > 0) {
      await new Promise((r) => setTimeout(r, delayMs));
      return fetchWithRetry(doFetch, retries - 1, delayMs);
    }
    throw err;
  }
}

export { API_BASE, STRIPE_PUBLISHABLE_KEY, isDev, fetchWithRetry };